import * as React from 'react';
import styled from 'styled-components';
import { useRef, useState } from 'react';
import useClickAway from 'react-use/esm/useClickAway';
const Wrapper = styled.div `
  position: relative;
  font-size: 20px;
`;
const ValueWrapper = styled.div ``;
const Value = styled.div ``;
const Placeholder = styled.div ``;
const MenuWrapper = styled.div `
  z-index: 999999;
  position: absolute;
  top: 0;
  right: 0;
  background: rgb(248, 248, 248);
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14),
    0px 2px 1px -1px rgba(0, 0, 0, 0.12);
`;
const MenuItem = styled.div `
  border-bottom: 1px solid rgb(242, 242, 242);
  padding: 16px;
  &:hover {
    background: rgb(240, 240, 240);
  }
`;
const Menu = ({ options, updateOpen, onChange, toName }) => {
    const ref = useRef(null);
    useClickAway(ref, () => {
        updateOpen(false);
    });
    return (React.createElement(MenuWrapper, { ref: ref }, options.map((option) => (React.createElement(MenuItem, { key: option, onClick: () => {
            onChange(option);
            updateOpen(false);
        } }, toName ? toName(option) : option)))));
};
const Select = ({ value, onChange, options, className, placeholder, toName }) => {
    const [open, updateOpen] = useState(false);
    return (React.createElement(Wrapper, { className: className },
        React.createElement(ValueWrapper, null, value ? (React.createElement(Value, { onClick: () => updateOpen(true) }, toName ? toName(value) : value)) : (React.createElement(Placeholder, { onClick: () => updateOpen(true) }, placeholder))),
        open && React.createElement(Menu, { options: options, updateOpen: updateOpen, onChange: onChange, toName: toName })));
};
export default Select;
